import { Link } from "@inertiajs/react";
import { Building2, Briefcase, Users, ShieldAlert } from "lucide-react";
import AppLayout from "../../layouts/AppLayout";
import { Input } from "../../components/ui/input";
import { useState } from "react";

interface Firm {
  id: number;
  name: string;
  candidate_count: number;
  placement_count: number;
  active_job_count: number;
  has_active_dnc: boolean;
}

interface Props {
  firms: Firm[];
}

export default function FirmsIndex({ firms }: Props) {
  const [q, setQ] = useState("");

  const filtered = q.trim()
    ? firms.filter((f) => f.name.toLowerCase().includes(q.toLowerCase()))
    : firms;

  return (
    <AppLayout title="Firms">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Firms</h1>
        <span className="text-sm text-gray-500">{firms.length} firms</span>
      </div>

      <div className="mb-4 max-w-sm">
        <Input
          placeholder="Search firms..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      <div className="bg-white rounded-lg border border-gray-200 divide-y divide-gray-100">
        {filtered.length === 0 && (
          <div className="py-12 text-center text-gray-400 text-sm">No firms found.</div>
        )}
        {filtered.map((firm) => (
          <Link
            key={firm.id}
            href={`/firms/${firm.id}`}
            className="no-underline flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <Building2 className="w-4 h-4 text-gray-400 flex-shrink-0" />
              <span className="text-sm font-medium text-gray-900">{firm.name}</span>
              {firm.has_active_dnc && (
                <ShieldAlert className="w-3.5 h-3.5 text-red-500 flex-shrink-0" title="Active DNC" />
              )}
            </div>
            <div className="flex items-center gap-4 text-xs text-gray-500">
              {firm.active_job_count > 0 && (
                <span className="flex items-center gap-1">
                  <Briefcase className="w-3 h-3" />
                  {firm.active_job_count}
                </span>
              )}
              {firm.placement_count > 0 && (
                <span className="flex items-center gap-1 text-green-600">
                  ✓ {firm.placement_count}
                </span>
              )}
              <span className="flex items-center gap-1">
                <Users className="w-3 h-3" />
                {firm.candidate_count}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </AppLayout>
  );
}
